import { render } from "./JustoppFooter.vue?vue&type=template&id=516838c1&scoped=true"
import script from "./JustoppFooter.vue?vue&type=script&lang=js"
export * from "./JustoppFooter.vue?vue&type=script&lang=js"

import "./JustoppFooter.vue?vue&type=style&index=0&id=516838c1&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-516838c1"]])

export default __exports__